import { render, staticRenderFns } from "./SchoolInfor.vue?vue&type=template&id=709cf011&scoped=true"
import script from "./SchoolInfor.vue?vue&type=script&lang=js"
export * from "./SchoolInfor.vue?vue&type=script&lang=js"
import style0 from "./SchoolInfor.vue?vue&type=style&index=0&id=709cf011&lang=css"
import style1 from "./SchoolInfor.vue?vue&type=style&index=1&id=709cf011&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709cf011",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('709cf011')) {
      api.createRecord('709cf011', component.options)
    } else {
      api.reload('709cf011', component.options)
    }
    module.hot.accept("./SchoolInfor.vue?vue&type=template&id=709cf011&scoped=true", function () {
      api.rerender('709cf011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/SchoolInfor.vue"
export default component.exports